<form [formGroup]="loginForm" (ngSubmit)="validateLoginPel()" *ngIf="!hasDataUser">
    <div>
        <app-mensajes [code]="code" [titulo]="titulo" [detalle]="detalle"></app-mensajes>
        <div class="register-photo" style="background-color:rgb(255,255,255);">
            <div class="form-container">
                <div class="form" style="align-self: center!important;">
                    <h3 style="text-align: center;"><strong>Acceso de Portal En Linea</strong></h3>
                    <p style="text-align: center;">Ingresa tus credenciales de acceso que utilizas en
                        portalenlinea.medicamentos.gob.sv</p>
                    <div class="input-group input-mid">
                    <input type="text" required formControlName="user" id="user" autocomplete="off"
                     pInputText class="ui-inputtext ui-widget" placeholder="Usuario de portalenlinea.medicamentos.gob.sv">
                    </div>
                    <div class="input-wrapper  input-mid" style="margin-bottom: 1rem;">
                        <input type="password" required formControlName="pass" id="pass" autocomplete="off"
                            placeholder="Contraseña" pInputText class="ui-inputtext ui-widget">
                    </div>
                    <div class="input-wrapper input-mid" style="margin-bottom: 1rem;">
                        <button type="submit" label="Verificar" pButton [disabled]="!loginForm.valid"></button>
                    </div>
                </div>
            </div>
        </div>
        <app-spinner [visible]="visibleSpinner"></app-spinner>
    </div>
</form>


<form [formGroup]="registroForm" (ngSubmit)="confirmarLoginPel()" *ngIf="hasDataUser && !finish">
    <div>
        <app-mensajes [code]="code" [titulo]="titulo" [detalle]="detalle"></app-mensajes>
        <div class="register-photo" style="background-color:rgb(255,255,255);">
            <div class="form-container">
                <div class="form" style="align-self: center!important;">
                    <h3 style="text-align: center;"><strong>Estas migrando tu usuario</strong></h3>
                    <p style="text-align: center;">Verifica tu información antes de continuar con el registro</p>
                    <br /><br />
                    <div class="p-grid p-formgrid">
                        <div class="p-field p-row-5">
                            <div class="input-group">
                                <span>Nombres</span>
                                <input type="text" required disabled [value]="dataUser.nombresUsuario" autocomplete="off" autofocus
                                    placeholder="Nombres" class="ui-inputtext ui-widget disabled-input" pInputText>
                            </div>
                        </div>
                        <div class="p-field p-row-5">
                            <div class="input-group">
                                <span>Apelllidos</span>
                                <input type="text" required disabled [value]="dataUser.apellidosUsuario" autocomplete="off" autofocus
                                    placeholder="Apellidos" class="ui-inputtext ui-widget disabled-input" pInputText>
                            </div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid">
                        <div class="p-field p-row-5">
                            <div class="input-group">
                                <span>Género</span>
                                <select formControlName="genero" required class="ui-inputtext ui-widget ng-pristine ng-invalid p-component p-inputselect p-filled ng-touched">
                                    <option disabled selected value>Seleccione</option>
                                    <option *ngFor="let item of generos" [selected]="item.value === dataUser.genero">{{ item.label }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="p-field p-row-5">
                            <div class="input-group">
                                <span>Tratamiento</span>
                                <select formControlName="tratamiento" required class="ui-inputtext ui-widget ng-pristine ng-invalid p-component p-inputselect ng-touched" #dropdown>
                                    <option disabled selected value>Seleccione</option>
                                    <option value="{{ item.value }}" *ngFor="let item of tratamientos">{{ item.label }}</option>
                                </select>
                            </div>
                        </div>

                    </div>
                    <div class="p-grid p-formgrid">
                        <div class="p-field p-row-5">
                            <div class="input-group">
                                <span>DUI</span>
                                <input type="text" required disabled [value]="dataUser.dui" autocomplete="off" autofocus
                                    placeholder="DUI/NIT" class="ui-inputtext ui-widget disabled-input" pInputText>
                            </div>
                        </div>
                        <div class="p-field p-row-5">
                            <div class="input-group">
                                <span>NIT</span>
                                <input type="text" required disabled [value]="dataUser.idUsuario" class="ui-inputtext ui-widget disabled-input" pInputText>
                            </div>
                        </div>

                    </div>
                    <div class="p-grid p-formgrid">
                        <div class="p-field p-row-5">
                            <div class="input-wrapper" style="margin-bottom: 1rem;">
                                <span>Correo electrónico</span>
                                <input type="email" formControlName="correo" required [value]="dataUser.emailsContacto" id="email" autocomplete="off" placeholder="mail@example.com" pInputText class="ui-inputtext ui-widget">
                            </div>
                        </div>
                        <div class="p-field p-row-5">
                            <div class="p-customMessage"> 
                            Es importante tener una dirección de correo electrónico vigente y válida, en esta dirección recibirás tu nueva contraseña de acceso. Si lo necesitas puedes ingresar una nueva dirección de correo.
                        </div>
                        </div>
                    </div>
                    <div class="p-col-12" style="text-align: center;">
                        <label for="">Antes de continuar, confirma que aceptas los <a style="color: #2196F3;  text-decoration: underline; cursor: pointer" (click)="showModal($event)">términos y condiciones de uso</a> de la ventanilla electrónica DNM </label>
                    </div>
                    <div class="input-wrapper input-mid" style="margin-bottom: 1rem;">
                        <button type="submit" label="Verificar" pButton [disabled]="!registroForm.valid"></button>
                    </div>
                </div>
            </div>
        </div>
        <app-spinner [visible]="visibleSpinner"></app-spinner>
    </div>
</form>

<div class="register-photo" style="background-color:rgb(255,255,255);" *ngIf="finish">
    
        <div class="form-container">
            <div class="form" style="align-self: center!important;"> 
                <div class="p-grid p-formgrid">
                    <div class="p-col-12"><h3>Se ha completado su registro</h3></div>
                    <div class="p-col-12"><p>Se ha enviado un código de confirmación a {{ mailUser }}.</p></div>
                    <div class="p-col-12"><button [routerLink]="'/auth/confirm-user'"  [state]="{ email: mailUser  }" class="custom-button" label="Continuar con el proceso de registro" pButton></button></div>
                </div>
       
    </div>
</div>
</div>


<p-dialog header="Términos y condiciones de uso de la ventanilla electrónica DNM " [(visible)]="displayModalConditions" [modal]="true">
	<div class="terms_conditions" style="padding: 0px 20px">
		<p>Leer detenidamente el presente contrato que contiene los términos y condiciones que regirán la utilización de la ventanilla electrónica DNM a través de la cual se tramitarán las solicitudes relativas a los servicios competencia de la Dirección Nacional de Medicamentos. </p>
	<ol>
		<li>Los derechos de titularidad y propiedad intelectual de la ventanilla electrónica DNM pertenecen a la Dirección Nacional de Medicamentos. Se prohíbe toda reproducción o representación por cualquier medio o motivo, de la referida ventanilla.</li>
		<li>Podrán realizar trámites, las personas naturales previamente registradas según el acceso otorgado, por medio de un usuario y contraseña. </li>
		<li>El acceso otorgado será de uso exclusivo de la persona solicitante y esta será responsable de su uso, por tanto, cualquier gestión que se realice a través del mismo, se entenderá realizada por su titular.</li>
		<li>La ventanilla electrónica DNM estará habilitada las veinticuatro horas para consulta e ingreso de trámites, no obstante, la recepción de los trámites fuera del horario de las 8:00 a las 16:00 horas de días hábiles, se entenderá recepcionado en el horario hábil siguiente.</li>
		<li>La DNM dará mantenimiento a la plataforma la ventanilla electrónica.</li>
        <li>La Dirección Nacional de Medicamentos verificará la identidad a través del usuario y contraseña.</li>
        <li>Las gestiones realizadas a través del usuario y contraseña ingresados en la ventanilla, tendrán la calidad de firma electrónica simple y, por tanto, la misma validez jurídica que la firma autógrafa, de conformidad a lo establecido en el artículo 6 de la Ley de firma electrónica.</li>
		<li>El usuario se compromete a usar adecuadamente el contenido y servicios ofrecidos en la ventanilla electrónica DNM, por tanto, el usuario se limitará al uso de la plataforma en el sentido de: </li>
		<ul>
			<li>No utilizar el contenido para incurrir y/o incitar a terceros a realizar actividades ilícitas, ilegales o contrarias a la buena fe y al orden público.</li>
			<li>No usar secuencias de comandos automatizadas para recopilar información publicada en la plataforma o a través de la misma o para interactuar de cualquier otro modo con estos.</li>
			<li>Intentar acceder, recolectar o almacenar los datos personales de otros administrados usuarios del portal y, en su caso, utilizar las cuentas de correo electrónico de otros administrados usuarios y modificar o manipular sus mensajes.</li>
		</ul>
		<li>La DNM no será responsable de:</li>
		<ul>
			<li>Los pagos erróneos efectuados en la gestión de sus trámites.</li>
			<li>Errores o mal funcionamiento de los ordenadores o dispositivos electrónicos. </li>
			<li>Información ingresada o requerida por terceros en ventanas emergentes no relacionadas  a la Ventanilla Electrónica DNM.</li>
			<li>Cambios aplicados al diseño, función, estructura o especificaciones de servicios prestados por terceros en la Ventanilla Electrónica DNM </li>
			<li>Inhabilitación de ventanas emergentes.</li>
			<li>Fallas en el suministro del servicio de internet contratado.</li>
			<li>Documentos cargados a la ventanilla electrónica DNM.</li>
			<li>Ingresar a vínculos remitidos por correos electrónicos o publicaciones que no sean emitidas por la DNM a través de sus cuentas oficiales.</li>
		</ul>
		<li>El usuario acepta como medio de notificación la ventanilla electrónica. Por lo cual toda notificación realizada deberá ser verificada en la Ventanilla Electrónica DNM, de conformidad a los artículos 97 y siguientes de la Ley de Procedimientos Administrativos.</li>
		<li>La DNM podrá desactivar, suspender o cancelar accesos a usuarios.</li>
	</ol>
    <p><b>El usuario declara la autenticidad y veracidad de la información consignada e ingresada en la ventanilla electrónica DNM, y que, en caso de no ser cierta dicha información, asume las consecuencias legales que de ello resulten. Asimismo, al crear la cuenta confirma que los datos y documentos proporcionados hacen referencia al titular de la cuenta.</b></p>

	<div class="p-col-12">
		<div class="checkbox">
			<p-checkbox name="groupname" (onChange)="changeConditions()" ></p-checkbox>
		</div>
		<label for="">Acepto los <a style="color: #2196F3;  text-decoration: underline; cursor: pointer" (click)="showModal()">términos y condiciones</a></label>
	</div>
	</div>	
</p-dialog>